module.exports = __webpack_public_path__ + "img/tooltip_11-vallone-litho-finish-fokos-rena.98b8ae67.jpg";